import { render, staticRenderFns } from "./_base-deleteConfirm.vue?vue&type=template&id=2ca28688&scoped=true&"
import script from "./_base-deleteConfirm.vue?vue&type=script&lang=js&"
export * from "./_base-deleteConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca28688",
  null
  
)

export default component.exports